import { makeStyles } from '@material-ui/core';

import { colors } from '../../theme/color-palette';
import {
	BOGLE_MEDIUM,
	BOGLE_REGULAR,
	SPACE_BETWEEN,
} from '../../constants/constant';

export const useStyles = makeStyles(() => ({
	table_customDrawer: {
		background: colors.WHITE,
		height: '960px',
		width: '360px',
		boxShadow: `0px 0px 10px 0px ${colors.BLACK}`,
	},
	table_customDrawerIcon: {
		width: '16px !important',
		height: '16px !important',
		marginRight: '8px',
		marginTop: '8px',
		marginBottom: '8px',
	},
	table_footerButtons: {
		boxSizing: 'border-box',
		position: 'fixed',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		bottom: '0px',
		borderTop: '1px solid',
		borderColor: colors.LIGHT_GRAY_SHADE,
		backgroundColor: colors.WHITE,
		height: '120px',
		zIndex: 3,
		marginLeft: '6px',
	},
	table_buttonBox: {
		display: 'flex',
		alignItems: 'center',
		paddingBottom: '8px',
	},
	table_container: {
		display: 'flex',
		overflow: 'hidden',
	},
	table_backBtn: {
		marginTop: '4px',
		marginLeft: '2px',
		width: '24px',
		height: '24px',
		flexShrink: 0,
		cursor: 'pointer',
		color: colors.DARK_GRAY_SHADE,
	},
	table_iconBackground: {
		width: '32px',
		height: '32px',
		'&:hover': {
			borderRadius: '100%',
			backgroundColor: colors.LIGHT_GRAY_SHADE,
		},
	},
	table_header: {
		padding: '22px 16px 0px 16px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: SPACE_BETWEEN,
		gap: '4px',
		marginBottom: '16px',
		position: 'absolute',
		background: colors.WHITE,
		zIndex: 3,
	},
	table_headerText: {
		display: 'inline-block',
		marginLeft: 8,
		fontFamily: 'Bogle',
		fontStyle: 'normal',
		color: colors.BLACK,
		fontSize: '24px',
		fontWeight: 400,
		lineHeight: '24px',
	},
	tableCategory: {
		display: 'flex',
		width: '360px',
		height: '40px',
		padding: '0px 16px',
		alignItems: 'center',
		gap: '8px',
		background: colors.WHITE,
	},
	table_dropdownIcon: {
		height: '16px',
		width: '16px',
		flexShrink: 0,
		paddingBottom: '8px',
	},
	table_toolbarBackground: {
		display: 'flex',
		width: '360px',
		padding: '8px 16px',
		alignItems: 'center',
		gap: '8px',
		background: colors.LIGHT_GRAY_SHADE,
		marginTop: '76px',
		flexDirection: 'row',
		position: 'fixed',
		zIndex: 3,
	},

	table_searchIcon: {
		paddingLeft: '16px',
		height: '100%',
		color: colors.GREY,
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'& .MuiSvgIcon-root': {
			width: '18px',
		},
	},

	table_filterMenu: {
		marginTop: '45px ',
	},
	table_drawerMenu: {
		position: 'fixed !important',
		width: '260px',
		padding: '4px 0px',
		flexDirection: 'column',
		alignItems: 'flex-start',
		marginLeft: '30px',
		borderRadius: '4px',
	},

	table_drawerMenuOptions: {
		backgroundColor: `${colors.WHITE}`,
	},

	table_filterOptions: {
		fontFamily: `${BOGLE_REGULAR}`,
	},

	table_columnTableButton: {
		height: '32px',
		width: '32px',
		scale: 1.15,
		color: `${colors.BLACK}`,
		backgroundSize: '32px',
		borderRadius: '32px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'&:hover': {
			cursor: 'pointer',
			backgroundColor: `${colors.LIGHT_GRAY_SHADE}`,
		},
	},

	table_metricContainer: {
		display: 'flex',
		flexDirection: 'column',
		marginTop: '200px',
		marginBottom: '120px',
		overflow: 'scroll',
		overflowX: 'hidden',
	},

	table_metricBorder: {
		borderTop: `1px solid var(--Stroke, ${colors.LIGHT_GRAY_SHADE})`,
		borderBottom: `1px solid var(--Stroke, ${colors.LIGHT_GRAY_SHADE})`,
	},

	table_metricOptions: {
		marginLeft: '40px',
		height: '32px',
	},

	table_checkbox: {
		borderColor: `${colors.PURPLE}`,
		'&:checked': {
			accentColor: `${colors.PURPLE}`,
		},
	},
	metricName: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: '4px',
		fontSize: '14px',
		fontStyle: 'normal',
		fontWeight: 500,
		lineHeight: '20px',
		marginLeft: '8px',
		fontFamily: `${BOGLE_MEDIUM} !important`,
	},
	table_buttonSave: {
		flex: 1,
		width: '328px',
		padding: '8px 8px !important',
		gap: '10px',
		boxSizing: 'border-box !important',
		color: `${colors.WHITE} !important`,
		'&:disabled': {
			backgroundColor: `${colors.PURPLE_INACTIVE} !important`,
		},
		textTransform: 'capitalize !important',
		borderRadius: '50px !important',
		backgroundColor: '#3c228a !important',
	},
	table_buttonSaveText: {
		fontStyle: 'normal',
		lineHeight: '24px',
	},
	table_buttonCancelText: {
		fontStyle: 'normal',
		lineHeight: '24px',
	},
	table_buttonCancel: {
		flex: 1,
		display: 'flex',
		width: '326px',
		boxSizing: 'border-box !important',
		padding: '6px 8px !important',
		gap: '10px',
		background: `${colors.WHITE}`,
		textTransform: 'capitalize !important',
		borderRadius: '50px !important',
	},

	tableCategoryText: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: '4px',
		fontSize: '14px !important',
		fontStyle: 'normal',
		fontWeight: 500,
		lineHeight: '20px',
		textTransform: 'capitalize',
		marginLeft: '8px',
		fontFamily: `${BOGLE_MEDIUM} !important`,
	},
	tableCategoryNumber: {
		height: '20px',
		width: '21px',
		fontSize: '14px !important',
		fontStyle: 'normal',
		fontWeight: 500,
		lineHeight: '20px',
		color: `${colors.MID_GREY}`,
		fontFamily: `${BOGLE_MEDIUM} !important`,
	},
	table_headerBackground: {
		background: `${colors.WHITE}`,
	},
	table_backBtnContainer: {
		display: 'flex',
		alignItems: 'center',
	},
	table_columnTableIcon: {
		marginTop: '3px',
	},
	table_searchContainer: {
		display: 'flex',
		alignItems: 'center',
	},
	filterMenuContainer: {
		marginLeft: '40%',
	},
	table_toolbarButton: {
		display: 'flex',
		padding: '6px 16px',
		alignItems: 'center',
		borderRadius: '20px',
		boxSizing: 'border-box !important',
		border: `1px solid ${colors.LIGHT_GRAY_SHADE}`,
		background: `${colors.WHITE}`,
		width: '130px',
		textTransform: 'none !important',
		'&:hover': {
			backgroundColor: `${colors.PURPLE_LIGHT}`,
		},
	},
	table_toolbarButtonText: {
		fontFamily: `${BOGLE_MEDIUM}`,
		color: `${colors.FONT_COLOR}`,
	},
	table_toolbarButtonContainer: {
		boxSizing: 'border-box !important',
		display: 'flex',
		flexDirection: 'row',
	},
	table_activeToolbarButton: {
		border: `1px solid var(--3-c-228-a, ${colors.PURPLE})`,
		display: 'flex',
		padding: '6px 0px',
		alignItems: 'center',
		borderRadius: '20px',
		background: `${colors.WHITE}`,
		textTransform: 'none',
		width: '129px',
		'&:hover': {
			backgroundColor: `${colors.PURPLE_LIGHT}`,
		},
	},
	table_search: {
		position: 'fixed',
		borderRadius: '4px',
		color: `${colors.GREY}`,
		width: '328px',
		height: '48px',
		marginLeft: '16px',
		marginTop: '335px',
		marginBottom: '16px',
		background: `${colors.WHITE}`,
		border: `1px solid ${colors.LIGHT_GREY}`,
		display: 'flex',
		justifyContent: `${SPACE_BETWEEN}`,
	},
	table_checkboxText: {
		position: 'relative',
		fontSize: '14px !important',
		top: -22,
		left: 23,
		color: `${colors.FONT_COLOR}`,
		fontFamily: `${BOGLE_REGULAR} !important`,
	},

	table_categoryNumberContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		position: 'relative',
		marginLeft: 'auto',
		marginRight: '40px',
	},

	table_input: {
		paddingLeft: '38px !important',
		height: '30px !important',
		fontFamily: `${BOGLE_REGULAR} !important`,
		fontSize: '14px !important',
		width: 270,
	},

	tryAgainButton: {
		display: 'flex !important',
		height: '52px !important',
		alignItems: 'center',
		'&:hover': {
			backgroundColor: 'transparent !important',
		},
	},
	tryAgainText: {
		color: colors.ERROR_HIGH,
		fontFamily: 'Bogle !important',
		fontSize: '14px',
		fontSeight: 400,
		lineHeight: '20px' /* 142.857% */,
		textDecorationLine: 'underline',
		textTransform: 'none',
	}
}));
